import { render, staticRenderFns } from "./Recurrence_Loyalty.vue?vue&type=template&id=2ca58007"
import script from "./Recurrence_Loyalty.vue?vue&type=script&lang=js"
export * from "./Recurrence_Loyalty.vue?vue&type=script&lang=js"
import style0 from "./Recurrence_Loyalty.vue?vue&type=style&index=0&id=2ca58007&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports